export const contact = {
  "contact.title": "Contact Us",
  "contact.subtitle": "Our team is here to help you. Feel free to contact us with any questions or suggestions.",
  "contact.form_title": "Send us a message",
  "contact.success": "Your message has been sent successfully! We will respond to you as soon as possible.",
  "contact.error": "An error occurred. Please try again later.",
  "contact.name": "Full name",
  "contact.email": "Email",
  "contact.type": "Request type",
  "contact.subject": "Subject",
  "contact.message": "Message",
  "contact.send": "Send message",
  "contact.sending": "Sending...",
  "contact.type_general": "General question",
  "contact.type_supplier": "Become a supplier",
  "contact.type_technical": "Technical support",
  "contact.type_partnership": "Partnership",
  "contact.type_feedback": "Feedback",
  "contact.info_title": "Contact information",
  "contact.address_title": "Address",
  "contact.address_text": "Office 234, GCL Plaza\n7th Avenue, Festac. LAGOS",
  "contact.phone_title": "Phone",
  "contact.email_title": "Email",
  "contact.email_text": "suji@olufona.com",
  "contact.hours_title": "Hours",
  "contact.hours_text": "Monday - Friday: 9:00 AM - 6:00 PM\nSaturday: 10:00 AM - 4:00 PM\nSunday: Closed",
  "contact.faq_title": "Frequently asked questions",
  "contact.faq_text": "Check our FAQ to quickly find answers to the most common questions.",
  "contact.see_faq": "See FAQ",
  "contact.placeholder_name": "Your full name",
  "contact.placeholder_email": "your@email.com",
  "contact.placeholder_subject": "Subject of your message",
  "contact.placeholder_message": "Describe your request in detail...",
  "contact.char_count": "characters",
  "contact.rate_limited": "Too many requests. Please try again later.",
  "contact.try_again_after": "Try again after",
  "contact.office_name": "Suji Office",
  "contact.office_address": "GCL Plaza, 7th Avenue, Festac, Lagos"
};

export default contact;
